/** API Core */
export const coreRolesRoute = 'roles';
export const coreUserByIdRoute = (userId: string) => `users/${userId}`;
export const coreRoleByTeamIdRoute = (teamId: string) => `roles/${teamId}`;
